import LazyLoader from 'imports/LazyLoader';

$(function() {
	const root = document.querySelector('[data-auth-page]');
	if(!root) {
		return;
	}
	LazyLoader.authPage()
		.then(({ default: initAuthPage }) => initAuthPage(root));
});
